import React, { useState, useEffect } from 'react'
import { Spinner } from 'app/theme/Spinner'

export default function AutoComplete(props) {
  const {
    value,
    label,
    error,
    CustomIcon,
    labelClassNames,
    inputClassNames,
    resultsClassNames,
    resultClassNames,
    placeholder = 'Search',
    useInitialOnMount = false,
    getInitialResults = () => { return null },
    onChange = () => {},
    onSelect = onChange,
    getResults = () => {},
    getLabel = () => {}
  } = props
  const [term, setTerm] = useState('')
  const [results, setResults] = useState(null)
  const [focused, setFocused] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    useInitialOnMount && fetchInitialResults();
  }, [])

  useEffect(() => {
    if (value) {
      setTerm(getLabel(value))
    } else {
      setTerm('')
    }
  }, [value])

  async function fetchInitialResults() {
    const initial = await getInitialResults()
    setResults(initial)
  }

  const handleInputChange = async event => {
    const val = event.target.value
    setTerm(val)

    if (val) {
      setLoading(true)
      const results = await getResults(val)
      setLoading(false)
      setResults(results || null)
    } else {
      onChange(null)
      setResults(null)
    }
  }

  return (
    <div className="relative">
      {label && (
        <label className={[labelClassNames, "label block mb-2"]}>
          {label}
        </label>
      )}
      <div className="relative flex items-center">
        <input
          type="text"
          placeholder={placeholder}
          value={term}
          onChange={handleInputChange}
          onFocus={() => {
            if (!results) {
              fetchInitialResults()
            }
            setFocused(true)
          }}
          onBlur={() => {
            setFocused(false)
            setResults(null)

            if (!value) {
              setTerm('')
            } else if (getLabel(value) !== term) {
              setTerm(getLabel(value))
            }
          }}
          className={[inputClassNames, "flex-1 px-3 py-2 focus:outline-none focus:border-blue"]}
        />
        <Spinner style={{height: "20px", width: "20px"}} className={["ml-2 text-blue", loading ? "visible" : "invisible"]}/>
        { CustomIcon && <CustomIcon className="mr-2 h-4 text-black" /> }
      </div>
      {error && (
        <div className="text-sm text-red-400 mt-1">
          {error}
        </div>
      )}
      {focused && results ? (
        <div
          className={[
            'bg-white shadow-xl rounded-sm absolute z-50 left-0 right-0 p-2',
            '-mx-1 border border-gray-500 grid gap-1',
            resultsClassNames,
          ]}
        >
          {!results.length && (
            <p className="text-gray-700 text-sm font-light p-1">
              No results found.
            </p>
          )}
          {results.map(rec => (
            <div
              key={rec.id}
              onMouseDown={() => {
                onChange(rec)
                setResults(null)
              }}
              className={[
                'cursor-pointer py-1 px-4 -mx-2 text-sm',
                'hover:bg-gray-100 rounded',
                resultClassNames
              ]}
            >
              {getLabel(rec)}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  )
}
